/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { JsonCompat } from '../../compat/JsonCompat';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IPropertyParent } from '../../core/models/common/IPropertyParent';
import { Schema } from '../../core/models/common/Schema';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete all properties from a schema.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllPropertiesCommand extends AbstractCommand {
    public _schemaPath : NodePath;

    public _oldProperties : Array<any>;

    public constructor(schema? : any) {
        if(((schema != null && (schema["__interfaces"] != null && schema["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IPropertyParent") >= 0 || schema.constructor != null && schema.constructor["__interfaces"] != null && schema.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IPropertyParent") >= 0)) || schema === null)) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            (() => {
                this._schemaPath = Library.createNodePath(<Node><any>schema);
            })();
        } else if(schema === undefined) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._oldProperties===undefined) this._oldProperties = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllPropertiesCommand] Executing.");
        this._oldProperties = <any>([]);
        let schema : IPropertyParent = <IPropertyParent><any>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        schema.getPropertyNames().forEach(((schema) => {
            return (pname) => {
                let data : any = JsonCompat.objectNode();
                JsonCompat.setPropertyString(data, Constants.PROP_NAME, pname);
                JsonCompat.setProperty(data, Constants.PROP_SCHEMA, Library.writeNode(schema.removeProperty(pname)));
                JsonCompat.setPropertyBoolean(data, Constants.PROP_REQUIRED, schema.isPropertyRequired(pname));
                schema.unsetPropertyRequired(pname);
                /* add */(this._oldProperties.push(data)>0);
            }
        })(schema));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllPropertiesCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldProperties) || /* size */(<number>this._oldProperties.length) === 0) {
            return;
        }
        let schema : IPropertyParent = <IPropertyParent><any>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        this._oldProperties.forEach(((schema) => {
            return (oldProp) => {
                let name : string = JsonCompat.getPropertyString(oldProp, Constants.PROP_NAME);
                let schemaObj : any = JsonCompat.getProperty(oldProp, Constants.PROP_SCHEMA);
                let required : boolean = JsonCompat.getPropertyBoolean(oldProp, Constants.PROP_REQUIRED);
                let prop : Schema = schema.createPropertySchema(name);
                Library.readNode(schemaObj, prop);
                schema.addProperty(name, prop);
                if(ModelUtils.isDefined(required) && required === true) {
                    schema.setPropertyRequired(name);
                }
            }
        })(schema));
    }
}
DeleteAllPropertiesCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllPropertiesCommand";
DeleteAllPropertiesCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




